<script>
  import {
    generateId,
  } from '../plugins/utils.js'

  export default {
    name: 'FabricRadio',

    model: {
      prop: 'modelValue',
      event: 'update'
    },
    props: {
      // modelValue prop should Never have a default
      // eslint-disable-next-line vue/require-default-prop
      modelValue: null,
      id: {
        type: [String, Number],
        default: (() => generateId()),
      },
      groupName: {
        type: String,
        default: '',
      },
      defaultSelected: {
        type: Boolean,
        default: false,
      },
      isNumerical:{
        type: Boolean,
        default: false,
      },
      value:{
        type: null,
        required: true,
      }
    },
    data() {
      return {
        modelValueBound: false, // assume not bound unless in `created` we can validate binding
        isSelected: false,
      }
    },
    computed: {
      computedId(){
        return `${this.id}__fb_radio__`
      }
    },
    watch:{
      modelValue(newValue, oldValue){
        if (newValue === this.value){
          this.isSelected = true
        }else{
          this.isSelected = false
        }
      }
    },
    created(){
      this.modelValueBound = Object.keys(this.$options.propsData).indexOf('modelValue') !== -1
      if (this.modelValueBound){
        this.isSelected = Boolean(this.value === this.modelValue)
      }else{
        this.isSelected = this.defaultSelected
      }
    },
    methods:{
      toggleChange(event){
        this.isSelected = true
        if (this.isNumerical && !(Number(this.value) === 0 && this.value !== 0)){
          this.$emit('update', Number(event.target.value))
        }else{
          this.$emit('update', event.target.value)
        }
      }
    }
  }
</script>

<template>
  <section
    :id="id + '__fb_radio__'"
    class="tw-flex tw-flex-row tw-items-center tw-w-full">
    <article class="tw-flex-col tw-inline-flex tw-items-start tw-w-6">
      <label
        :for="id + '__fb_radio__input'" 
        :class="[
          'tw-h-4 tw-w-4',
          'tw-mb-u',
          'tw-border tw-border-gray-500 tw-rounded-10',
          'tw-bg-white',
          'tw-transition-[border-width]',
          {
            '!tw-border-[5px] !tw-border-primary': isSelected,
          }]"/>
      <input 
        v-if="modelValueBound"
        :id="id + '__fb_radio__input'" 
        class="tw-hidden"
        type="radio"
        :name="groupName"
        :checked="isSelected"
        :value="value"
        @change="toggleChange">
      <input 
        v-else
        :id="id + '__fb_radio__input'" 
        class="tw-hidden"
        type="radio"
        :name="groupName"
        :checked="isSelected"
        :value="value"
        @change="toggleChange">
    </article>
    <article class="tw-w-auto">
      <label 
        :for="id + '__fb_radio__input'" 
        class="tw-font-semibold tw-text-sm !tw-leading-[17px] tw-mb-u"><slot/></label>
    </article>
  </section>
</template>
